import utils from 'utils'

class accountListCtrl {
  constructor(
    $scope,
    sweetalert,
    $state,
    httpRequest,
    logger,
    $timeout,
    $uibModal
  ) {
    $scope.isReconciled = true
    $scope.reconciledResult = {}
    $scope.currentPeriod = ''
    // 对账模式
    $scope.accountModel = -1
    $scope.voucherCodeStyle = (index) => {
      if (index !== 0) {
        return {
          cursor: 'pointer',
          color: '#2A88F5',
        }
      }
      return {}
    }
    function tableStyleChange() {
      let compareInfoNum = 0
      let financeNum = 0
      let invoiceNum = 0

      $scope.customizedConfig.table.forEach((item, index) => {
        if (index < 3 && item.selected) {
          compareInfoNum++
        }
        if (index > 2 && item.selected && index < 7) {
          financeNum++
        }
        if (index > 6 && item.selected) {
          invoiceNum++
        }

        $scope.colspan = {
          compareInfo: compareInfoNum,
          finance: financeNum,
          invoice: invoiceNum,
        }
      })

      $timeout(() => {
        // 总税额比对模式表格样式
        if ($scope.accountModel === 2) {
          $('.total-taxamt-account-table')
            .children()
            .children()
            .css('border-right', 'none')
          let i = $('.total-taxamt-account-table').children().length
          for (let j = 0; j < i; j++) {
            $('.total-taxamt-account-table')
              .children()
              .eq(j)
              .children()
              .eq(compareInfoNum)
              .css('border-right', '1px solid #aaa')
            $('.total-taxamt-account-table')
              .children()
              .eq(j)
              .children()
              .eq(compareInfoNum + financeNum)
              .css('border-right', '1px solid #aaa')
            $('.total-taxamt-account-table')
              .children()
              .eq(j)
              .children()
              .last()
              .css('border-right', '1px solid #CDD0D1')
          }
        } else {
          $('.other-account-table')
            .children()
            .children()
            .css('border-right', '1px solid #CDD0D1')
          let i = $('.other-account-table').children().length
          for (let j = 0; j < i; j++) {
            $('.other-account-table')
              .children()
              .eq(j)
              .children()
              .eq(compareInfoNum)
              .not('.invInfoTd')
              .css('border-right', '1px solid #aaa')
            $('.other-account-table')
              .children()
              .eq(j)
              .children()
              .eq(compareInfoNum + financeNum)
              .not('.invInfoTd')
              .css('border-right', '1px solid #aaa')
          }
        }
        $('.complex-thead-th-add-right-border').css(
          'border-right',
          '1px solid #aaa'
        )
        $('.complex-thead-th')
          .children()
          .css('border-right', '1px solid #CDD0D1')
          .css('border-left', '1px solid #CDD0D1')
        $('.complex-thead-th')
          .children()
          .eq(compareInfoNum)
          .css('border-right', '1px solid #aaa')
        $('.complex-thead-th')
          .children()
          .eq(compareInfoNum + financeNum)
          .css('border-right', '1px solid #aaa')
      })
    }

    $scope.$watch(
      'customizedConfig',
      (newVal, oldVal) => {
        if (newVal !== oldVal && newVal && oldVal) {
          tableStyleChange()
        }
      },
      true
    )

    function qryVoucherAccountList(searchLayer, accountStatus) {
      httpRequest
        .post_qryVoucherAccountList($scope.params)
        .then((res) => {
          let ivatCompareResultDTO = []
          if (!res.data.value) {
            $scope.isReconciled = false
          }
          if (
            res.data.value &&
            res.data.value.ivatCompareResultDTO &&
            res.data.value.ivatCompareResultDTO.length > 0
          ) {
            $scope.reconciledResult = Object.assign(
              $scope.reconciledResult,
              res.data.value
            )
            const resTmp = res.data.value.ivatCompareResultDTO.slice()
            resTmp.forEach((item) => {
              if (!item.invoiceDetail || item.invoiceDetail.length === 0) {
                ivatCompareResultDTO.push({
                  ...item,
                  $invoiceDetailitemLength: 1,
                })
              } else {
                item.invoiceDetail.forEach((item1) => {
                  ivatCompareResultDTO.push({
                    ...item,
                    ...item1,
                    $invoiceDetailitemLength: item.invoiceDetail.length,
                  })
                })
              }
            })
          }
          $scope.ivatCompareResultDTO = ivatCompareResultDTO.slice()
        })
        .finally(() => {
          if (
            accountStatus === 1 ||
            (accountStatus === -1 &&
              $scope.reconciledResult.accountStatus === 1)
          ) {
            sweetalert
              .confirm(
                '提醒',
                '本次对账已经相符，是否确认？若确认，后续新增的发票数据将取消自动比对，新数据的比对需手工点击【对账】按钮！'
              )
              .then(() => {
                httpRequest.post_doComfire()
              })
          }
          window.layer.close(searchLayer)
          // 强制触发一次watch函数
          $timeout(() => {
            tableStyleChange()
          })
        })
    }
    function qryTotalTaxamtAccountList(searchLayer, accountStatus) {
      httpRequest
        .post_qryTotalTaxamtAccountList($scope.params)
        .then((res) => {
          let ivatCompareResultDTO = []
          if (!res.data.value) {
            $scope.isReconciled = false
          }
          if (
            res.data.value &&
            res.data.value.ivatCompareResultDTO &&
            res.data.value.ivatCompareResultDTO.length > 0
          ) {
            $scope.reconciledResult = Object.assign(
              $scope.reconciledResult,
              res.data.value
            )
            ivatCompareResultDTO = res.data.value.ivatCompareResultDTO.slice()
          }
          $scope.ivatCompareResultDTO = ivatCompareResultDTO.slice()
        })
        .finally(() => {
          if (
            accountStatus === 1 ||
            (accountStatus === -1 &&
              $scope.reconciledResult.accountStatus === 1)
          ) {
            sweetalert
              .confirm(
                '提醒',
                '本次对账已经相符，是否确认？若确认，后续新增的发票数据将取消自动比对，新数据的比对需手工点击【对账】按钮！'
              )
              .then(() => {
                httpRequest.post_doComfire()
              })
          }
          window.layer.close(searchLayer)
          // 强制触发一次watch函数
          $timeout(() => {
            tableStyleChange()
          })
        })
    }
    function searchlist(layer, accountStatus = -1) {
      const searchLayer =
        layer ||
        window.layer.msg('查询中，请耐心等待...', {
          time: 0,
          skin: 'layer-loading-self',
          icon: 16,
          shade: 0.5,
        })
      if ($scope.accountModel === 2) {
        delete $scope.params.adjustDesc
        delete $scope.params.invocieAccountStatus
        qryTotalTaxamtAccountList(searchLayer, accountStatus)
      } else {
        qryVoucherAccountList(searchLayer, accountStatus)
      }
    }
    $scope.periodCodeChange = () => {
      httpRequest
        .get_checkAccountIsConfire($scope.params.periodCode)
        .then((res) => {
          $scope.accountModel = res.data.value.accountModel
          searchlist(undefined, 3)
        })
    }
    async function reconciliationAndSearch(reconciliationByhand = false) {
      let res = await httpRequest.get_checkAccountIsConfire()

      $scope.accountModel = res.data.value.accountModel

      const layer = window.layer.msg(
        `${
          res.data.value.accountStatus !== 3 || reconciliationByhand
            ? '对账中'
            : '查询中'
        }，请耐心等待...`,
        {
          time: 0,
          skin: 'layer-loading-self',
          icon: 16,
          shade: 0.5,
        }
      )
      if (res.data.value.accountStatus !== 3 || reconciliationByhand) {
        await httpRequest.post_reconciliation()
        res = await httpRequest.get_checkAccountIsConfire()
      }

      searchlist(layer, res.data.value.accountStatus)
    }
    async function init() {
      let res = await httpRequest.get_qryOrgTaxPeriod(
        JSON.parse(localStorage.user_info).user.currentOrgId
      )

      if (res.data.value && res.data.value.periodCode) {
        $scope.params.periodCode = `${res.data.value.periodCode.slice(
          0,
          4
        )}-${res.data.value.periodCode.slice(4)}`
        $scope.currentPeriod = res.data.value.periodCode
      }

      if (!$scope.params.periodCode) {
        $scope.params.periodCode =
          new Date().getFullYear() +
          '-' +
          ('0' + (1 + new Date().getMonth())).slice(-2)
        $scope.currentPeriod = $scope.params.periodCode.replace('-', '')
      }

      await $timeout(() => {
        $('#taxPeriod').datetimepicker({
          startView: 3,
          autoclose: true,
          minView: 'year',
          language: 'zh-CN',
          format: 'yyyymm',
          forceParse: 0,
          pickTime: false,
          pickerPosition: 'bottom-right',
          endDate: $scope.params.periodCode,
          initialDate: $scope.params.periodCode,
        })
      })

      $scope.params.periodCode = $scope.params.periodCode.replace('-', '')

      reconciliationAndSearch()
    }
    init()

    httpRequest
      .get_dictByTypeArr([
        'ivat_check_status',
        'ivat_voucher_inv_type',
        'ivat_account_status',
        'ivat_inv_type',
      ])
      .then((res) => {
        $scope.dictData = res.data.value
      })

    $scope.ivatCompareResultDTO = []

    $scope.scanModal = () => {
      reconciliationAndSearch(true)
    }
    $scope.params = {
      invocieAccountStatus: '',
      adjustDesc: '',
      voucherCode: '',
      subjectName: '',
      invoiceType: '',
      invoiceNumber: '',
      invoiceDateBegin: '',
      invoiceDateEnd: '',
      checkStatus: '',
      periodCode: '',
    }
    $scope.reset = () => {
      $scope.params = Object.assign($scope.params, {
        invocieAccountStatus: '',
        adjustDesc: '',
        voucherCode: '',
        subjectName: '',
        invoiceType: '',
        invoiceNumber: '',
        invoiceDateBegin: '',
        invoiceDateEnd: '',
        checkStatus: '',
      })
    }
    $scope.colspan = {
      compareInfo: 3,
      finance: 4,
      invoice: 9,
    }
    $scope.customizedConfig = {
      version: 1.01,
      table: [
        {
          label: '对账结果',
          selected: true,
          default: true,
        },
        {
          label: '差异',
          selected: true,
          default: true,
        },
        {
          label: '调整说明',
          selected: true,
          default: true,
        },
        {
          label: '凭证号码',
          selected: true,
          default: true,
        },
        {
          label: '科目名称',
          selected: true,
          default: true,
        },
        {
          label: '借方金额',
          selected: true,
          default: true,
        },
        {
          label: '贷方金额',
          selected: true,
          default: true,
        },
        {
          label: '票据种类',
          selected: true,
          default: true,
        },
        {
          label: '发票代码',
          selected: true,
          default: true,
        },
        {
          label: '发票号码',
          selected: true,
          default: true,
        },
        {
          label: '开票日期',
          selected: true,
          default: true,
        },
        {
          label: '金额',
          selected: true,
          default: true,
        },
        {
          label: '税额',
          selected: true,
          default: true,
        },
        {
          label: '价税合计',
          selected: true,
          default: true,
        },
        {
          label: '销方名称',
          selected: true,
          default: true,
        },
        {
          label: '勾选状态',
          selected: true,
          default: true,
        },
      ],
    }

    $scope.tableDropdownConfig = [
      {
        label: '调整发票',
        handler(item) {
          $scope.adjustInvoice(item)
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('adjust_invoice') &&
            ($scope.currentPeriod === $scope.params.periodCode ||
              !$scope.currentPeriod) &&
            item.invocieAccountStatus !== 1 &&
            $scope.accountModel !== 2
          )
        },
      },
      {
        label: '调整差异',
        handler(item) {
          $scope.adjustDifferences(item)
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('adjust_differences') &&
            ($scope.currentPeriod === $scope.params.periodCode ||
              !$scope.currentPeriod) &&
            item.invocieAccountStatus !== 1 &&
            (item.invoiceDetail || $scope.accountModel === 2)
          )
        },
      },
      {
        label: '删除关联',
        handler(item) {
          sweetalert
            .confirm(
              '删除提醒',
              '确定删除？删除后，发票与凭证的关联关系将取消,可能导致对账不相符！'
            )
            .then(() => {
              const layer = window.layer.msg('正在删除中，请耐心等待...', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
              })
              httpRequest
                .post_delRelationInvoice({ voucherId: item.voucherId })
                .then(() => {
                  searchlist(layer)
                })
            })
        },
        showWhile(item, hasPermit) {
          return (
            hasPermit('delete_adssociation') &&
            ($scope.currentPeriod === $scope.params.periodCode ||
              !$scope.currentPeriod) &&
            $scope.accountModel !== 2 &&
            item.invoiceDetail
          )
        },
      },
    ]

    $scope.export = () => {
      let _url = `${
        host.etcloudIvatApp
      }voucher/ivatVoucherAccount/exportVoucherAccountList?accessToken=${localStorage.getItem(
        'id_token'
      )}`
      utils.post_downLoad($scope.params, _url)
    }

    $scope.adjustInvoice = (item) => {
      $uibModal
        .open({
          templateUrl: 'adjustInvoice.html',
          controller: 'adjustInvoiceCtrl',
          openedClass:
            'mod-modal-haslist mod-modal mod-modal-lg modal-reconciliation-account-adjust-invoice',
          backdrop: 'static',
          resolve: {
            items1() {
              const {
                creditAmt,
                debitAmt,
                accountDate,
                subjectName,
                voucherCode,
              } = item
              const data = {
                creditAmt,
                debitAmt,
                accountDate,
                subjectName,
                voucherCode,
                invoiceDetail:
                  (item.invoiceDetail && item.invoiceDetail.slice()) || [],
              }
              return data
            },
          },
        })
        .result.then(() => {
          const layer = window.layer.msg(
            '调整完成，正在对账中，请耐心等待...',
            {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            }
          )
          searchlist(layer)
        })
    }

    $scope.adjustDifferences = (item) => {
      $uibModal
        .open({
          templateUrl: 'adjustDifferences.html',
          controller: [
            '$scope',
            '$uibModalInstance',
            'items',
            function ctrl(scope, uibModalInstance, items) {
              scope.oldAdjustAmt = items.adjustAmt
              scope.param = { adjustAmt: '', ...items }
              scope.cancel = function cancel() {
                uibModalInstance.dismiss()
              }
              scope.ok = function ok() {
                if (!scope.param.adjustAmt) {
                  logger.logError('比对差异为必填项，请修改')
                  return
                }
                if (+scope.param.adjustAmt !== +scope.param.adjustAmt) {
                  logger.logError('比对差异必须为数字，请修改')
                  return
                }
                if (
                  (scope.param.adjustAmt.split('.')[0] || []).length +
                    (scope.param.adjustAmt.split('.')[1] || []).length >
                  15
                ) {
                  logger.logError('比对差异输入的数值过长，不可超过15位！')
                  return
                }
                if (
                  !scope.param.adjustDesc ||
                  scope.param.adjustDesc.length > 25
                ) {
                  logger.logError('调整说明为必填项，最多25个字符，请修改')
                  return
                }
                httpRequest.post_updateVoucherDiff(scope.param).then(() => {
                  uibModalInstance.close()
                })
              }
            },
          ],
          openedClass:
            'mod-modal mod-modal-md modal-reconciliation-account-adjust-differences',
          backdrop: 'static',
          resolve: {
            items() {
              const { voucherId, differentAmt, adjustDesc, adjustAmt } = item
              const data = {
                voucherId,
                differentAmt,
                adjustDesc,
                adjustAmt,
              }
              return data
            },
          },
        })
        .result.then(() => {
          const layer = window.layer.msg(
            '调整完成，正在对账中，请耐心等待...',
            {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            }
          )
          searchlist(layer)
        })
    }

    $scope.abstractModal = (item, index) => {
      if (index === 0) {
        return
      }
      $uibModal.open({
        templateUrl: 'abstractModal.html',
        controller: [
          '$scope',
          '$uibModalInstance',
          'items1',
          function ctrl(scope, uibModalInstance, items1) {
            scope.voucherAbstract = items1.voucherAbstract
            scope.cancel = function cancel() {
              uibModalInstance.dismiss()
            }
            scope.ok = function ok() {
              uibModalInstance.close()
            }
          },
        ],
        openedClass: 'mod-modal mod-modal-md',
        backdrop: 'static',
        resolve: {
          items1() {
            return { voucherAbstract: item.voucherAbstract || '' }
          },
        },
      })
    }

    $scope.searchlist = () => {
      searchlist(undefined, 3)
    }
  }
}

accountListCtrl.$inject = [
  '$scope',
  'sweetalert',
  '$state',
  'httpRequest',
  'logger',
  '$timeout',
  '$uibModal',
]

export default accountListCtrl



// WEBPACK FOOTER //
// ./src/app/input/financialCounting/reconciliationAccount/accountListCtrl.js